import { Row, Col, Collapse, Table, Input, Icon, Alert, Select, Anchor, Spin } from 'antd';
import { SET_FILTER_DATA } from '../../../redux/actions/reportAction';
import { CSVLink } from 'react-csv';
import store from 'store';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { Link } = Anchor;

const
{ setEnvPrefix } = ssCommonUtils,
{ Search } = Input.Search;

export default class ReportResults extends React.Component {
    state = { perPage: 10 }
    constructor(props) { super(props); }

    setTableData(payload){
      store.dispatch({
          type: SET_FILTER_DATA,
          payload: payload
      });
    }

    getDownloadLink(){
      if(this.props.reportMetaData && this.props.reportMetaData.downloadable)
      return (<CSVLink data={this.getDataInfo()} headers={this.getHeaderInfo()} ><Icon type="download" /></CSVLink>)

    }

    getPaginationProperties(){
      if(this.props.reportMetaData && this.props.reportMetaData.paging){
        return ({ pageSize:this.state.perPage,showSizeChanger:true, pageSizeOptions:JSON.parse("[" + this.props.reportMetaData.paging + "]"),showTotal:(total, range) => `${range[0]}-${range[1]} of ${total} items`  })
      } else {
        return ({ pageSize:this.state.perPage,showTotal:(total, range) => `${range[0]}-${range[1]} of ${total} items`  })
      }

    }

    searchTable(e){
      var text =  e.target.value;
      var newFilteredData =[];
      if(text!=null && text.length>0){
          var i =0;
          for(var j=0;j<this.props.data.length;j++){
            for(var k=0;k<this.props.columns.length;k++){

                var colName = this.props.columns[k].index;
                if(this.props.data[j][`${colName}`]!=null &&
                  this.props.data[j][`${colName}`].toString().toLowerCase().includes(text.toLowerCase())
                ){
                  newFilteredData[i] = this.props.data[j];
                  i++;
                }
            }
          }

      } else {
          newFilteredData = this.props.data;
      }
      this.setTableData(newFilteredData);
    }

    getHeader = () => {
        const selectSearchField = (
            <Select defaultValue={this.state.searchField }style={{ width: 120 }} onSelect={(e) => this.setState({searchField: e,})}>
                <Option value='location'>Location</Option>
                <Option value='city'>City</Option>
                <Option value='state'>State</Option>
                <Option value='country'>Country</Option>
                <Option value='airport'>Airport Code</Option>
            </Select>
        )

        return(
            <div>
            <Row type="flex" justify="end">
                <Col span={4}>
                    <h5>Items Per Page:&nbsp;&nbsp;&nbsp;
                        <Select defaultValue={this.state.perPage} onSelect={(e) => this.onPerPageSelect(e)}>
                            <Select.Option value={10}>10</Select.Option>
                            <Select.Option value={25}>25</Select.Option>
                            <Select.Option value={50}>50</Select.Option>
                            <Select.Option value={100}>100</Select.Option>
                            <Select.Option value={200}>200</Select.Option>
                        </Select>
                    </h5>
                </Col>
            </Row>
            </div>
        );
    }


    onPerPageSelect = (e) => {
        this.setState({
            perPage: e,
        })
    }

    getHeaderInfo(){
      const header =
         this.props.columns.filter(column => {return (column.viewable)

         }  ).map(column=>
           {
               return({
                 label: column.name,
                 key: column.index.replace('.','')
               })
            })
         return header;
    }

    openNewWindow = (link) => {
      window.open(setEnvPrefix(link));
    }

    getDataInfo(){

      const data =
         this.props.data.map(row => {
            var dataRow = {};
           this.props.columns.forEach(column=>
           {
             if(column.viewable){
                 dataRow[column.index.replace('.','')] = row[column.index];
              }
            })

            return dataRow;
          })
      return data;
    }

    handleLoading(){
        const antIcon = <Icon type="loading" style={{fontSize: '96', display: 'block', width: '80%'}} spin />;
        return (
            <div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                    <Spin indicator={antIcon} size="large" />
                </Row>
            </div>
        );
    }

    render() {
       console.log("********************", this.props)

        const columns =
           this.props.columns.map(column=>
             {
               if(column.viewable){
                 if(!column.decoration){
                   if(!this.props.columnWidths)
                   {
                     return({
                       title: column.name,
                       dataIndex: column.index,
                       key: column.index,
                       render: (text, record, index) => {
                           return (<span>{text}</span>);
                       },
                       sorter: (a, b) => {
                      	 let c = a[column.index] || '';
                      	 let d = b[column.index] || '';
                         if(!isNaN(c) && !isNaN(d)){
                           return c-d;
                         }
                      	 return c.toString().localeCompare(d.toString(), undefined, {numeric:true});
                       }
                     })}
                     else{
                       var columnName = column.name;
                       return({
                       title: column.name,
                       dataIndex: column.index,
                       key: column.index,
                       width: this.props.columnWidths.columnName,
                       render: (text, record, index) => {
                           return (<span>{text}</span>);
                       },
                       sorter: (a, b) => {
                      	 let c = a[column.index] || '';
                      	 let d = b[column.index] || '';
                         if(!isNaN(c) && !isNaN(d)){
                           return c-d;
                         }
                      	 return c.toString().localeCompare(d.toString());
                       }
                     })
                   }
                   } else {
                     if(!this.props.columnWidths) {
                       return({
                         title: column.name,
                         dataIndex: column.index,
                         key: column.index,
                         render: (text, record, index) => {
                                var modDecoration = column.decoration;

                                this.props.columns.map(docColumn=>{
                                  if(column.decoration.indexOf('%'+docColumn.index) != -1)
                                    modDecoration = modDecoration.replace('%'+docColumn.index, record[`${docColumn.index}`])
                                })

                                Object.keys(this.props.formData).forEach((key) => {
                                    if(this.props.formData[key]){
                                      if(column.decoration.indexOf('%'+key) != -1)
                                        var typeVar = typeof this.props.formData[key];
                                        console.log("the format is", typeVar);
                                        if(typeVar== 'object'){
                                          modDecoration = modDecoration.replace('%'+key, this.props.formData[key].local().format('YYYY-MM-DD'))
                                        } else {
                                          modDecoration = modDecoration.replace('%'+key, this.props.formData[key])
                                        }
                                    } else {
                                      modDecoration = modDecoration.replace('%'+key, '')
                                    }
                                  })

                                  if (this.props.orgId === -1) {
                                    if(text !== 'UNKNOWN') {
                                      return (<a onClick={(e) =>this.openNewWindow(modDecoration)} >{text}</a>);
                                    } else {
                                      return (<span>{text}</span>);
                                    }
                                  } else {
                                    return (<span>{text}</span>);
                                  }
                              },
                         sorter: (a, b) => {
                       	  let c = a[column.index] || '';
                        	  let d = b[column.index] || '';
                        	  return c.toString().localeCompare(d.toString());
                         }
                       })
                     } else {
                       var columnName = column.name;
                       return({
                         title: column.name,
                         dataIndex: column.index,
                         key: column.index,
                         width: this.props.columnWidths.columnName,
                         render: (text, record, index) => {
                                var modDecoration = column.decoration;

                                this.props.columns.map(docColumn=>{
                                  if(column.decoration.indexOf('%'+docColumn.index) != -1)
                                    modDecoration = modDecoration.replace('%'+docColumn.index, record[`${docColumn.index}`])
                                })

                                Object.keys(this.props.formData).forEach((key) => {
                                    if(this.props.formData[key]){
                                      if(column.decoration.indexOf('%'+key) != -1)
                                        if(this.props.formData[key].typeof== 'moment'){
                                          modDecoration = modDecoration.replace('%'+key, this.props.formData[key].local().format('YYYY-MM-DD'))
                                        } else {
                                          modDecoration = modDecoration.replace('%'+key, this.props.formData[key])
                                        }
                                    }  else {
                                      modDecoration = modDecoration.replace('%'+key, '')
                                    }
                                  })

                                  if (this.props.orgId === -1) {
                                    return (<a onClick={(e) =>this.openNewWindow(modDecoration)} >{text}</a>);
                                  } else {
                                    return (<span>{text}</span>);
                                  }   
                              },
                         sorter: (a, b) => {
                       	  let c = a[column.index] || '';
                        	  let d = b[column.index] || '';
                        	  return c.toString().localeCompare(d.toString());
                         }
                       })
                     }
                  }
                }  else return ({})
              })

        if(this.props.resultRequestStatus=="success"){

        return (
            <div>

                <Row style={{ marginBottom: '20px' }}>
                    <Col span={23} style={{ width: '100%' }}>
                        <Collapse defaultActiveKey='1'>
                              <Collapse.Panel
                                disabled={true}
                                key='1'
                                header={
                                  <div style={{ width: '100%'}}>
                                  <div style={{
                                    display: 'inline-block',
                                        fontSize: '16px',
                                      fontWeight: 'bold'}}>
                                        {'Results'}
                                    </div>
                                    <div style={{
                                      display: 'inline-block',
                                      textAlign: 'right',
                                      width: '100%',
                                      padding: '5px'
                                    }}>
                                    {this.getDownloadLink()}&nbsp;
                                    <Input
                                      placeholder="Search on table"
                                      onPressEnter={(value) => this.searchTable(value)}
                                      style={{ width: 250 }}
                                            />

                                    </div>
                                  </div>
                                }
                            >
                                <Row>
                                    <Col span={24}>
                                        <Table
                                            size='medium'
                                            title={() => this.getHeader()}
                                            columns={columns}
                                            dataSource={this.props.filteredData}
                                            bordered={false}
                                            loading={this.props.loadingResults}
                                            pagination={this.getPaginationProperties()}
                                            scroll={{x:800}}
                                        />
                                    </Col>
                                </Row>
                            </Collapse.Panel>
                        </Collapse>
                    </Col>
                </Row>
            </div>
        );}
        else if(this.props.resultRequestStatus=="failure"){
          return(<div><Alert message="Error" description="Error getting report data." type="error"/></div>)
        } else if (this.props.resultRequestStatus == "trying") {
        	return (this.handleLoading())
    	} else {
          return(<div></div>)
        }
    }
}
